import type {} from "redux-thunk/extend-redux";

import { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./scss/klasis.scss";
import FullScreenLoader from "./components/FullScreenLoader";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { createInstance, MatomoProvider } from "@jonkoops/matomo-tracker-react";
import motomoConfig from "./configuration/motomo";
import { CookiesProvider } from "react-cookie";
import axios from "axios";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./store";
import { defaultLocale } from "./constants/languages";

const matomoTrackerInstance = createInstance(motomoConfig);

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

ReactDOM.render(
    <Suspense fallback={<FullScreenLoader />}>
        <MatomoProvider value={matomoTrackerInstance}>
            <CookiesProvider>
                <BrowserRouter>
                    <Provider store={store}>
                        <PersistGate
                            loading={<FullScreenLoader />}
                            persistor={persistor}
                        >
                            <Routes>
                                <Route path="/:locale/*" element={<App />} />
                                <Route
                                    path="*"
                                    element={
                                        <Navigate
                                            to={`/${defaultLocale}`}
                                            replace
                                        />
                                    }
                                />
                            </Routes>
                        </PersistGate>
                    </Provider>
                </BrowserRouter>
            </CookiesProvider>
        </MatomoProvider>
    </Suspense>,
    document.getElementById("root")
);
